var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footbar"},[_vm._t("default"),_c('div',{staticClass:"footbar"},[_vm._t("footbar")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }